/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 积分商城商品缺货登记
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  commodityId: number,
  specsRelationId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/member/record/commodity-specs/${commodityId}/${specsRelationId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
